<template>
  <div>
    <WheelSpinEvent v-if="$store.state.config.pdd_activity && $store.state.isShowWheelSpinEvent"></WheelSpinEvent>
    <DownHeader35 v-if="config.ui_version == 3.5"></DownHeader35>
    <HomeConter v-if="config.ui_version == 3.0"></HomeConter>
    <HomeConterDian1 v-if="config.ui_version == 3.1"></HomeConterDian1>
    <HomeConterDian4 v-if="config.ui_version == 3.4"></HomeConterDian4>
    <four v-if="config.ui_version == 3.5"></four>
    <HomeSanDianLiu v-if="config.ui_version == 3.6"></HomeSanDianLiu>
    <Home3Dian7 v-if="config.ui_version == 3.7"></Home3Dian7>
    <Home3Dian8 v-if="config.ui_version == 3.8"></Home3Dian8>
  </div>
</template>

<script>
import DownHeader35 from '@/components/header/index3.5.vue';
import HomeConter from '@/components/home/HomeConter.vue';
import HomeConterDian1 from '@/components/home/HomeConterDian1.vue';

import HomeConterDian4 from '@/components/home/HomeConterDian4.vue';
import four from '@/components/home/four.vue';
import HomeSanDianLiu from '@/components/home/HomeSanDianLiu.vue';
import Home3Dian7 from '@/components/home/Home3Dian7.vue';
import Home3Dian8 from '@/components/home/Home3Dian8.vue';
import WheelSpinEvent from '@/components/wheel-spin-event.vue';

import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['popList', 'userInfo', 'moneyInfo', 'config'])
  },
  name: 'Home',
  components: {
    HomeConter,
    HomeConterDian1,
    HomeConterDian4,
    four,
    HomeSanDianLiu,
    Home3Dian7,
    Home3Dian8,
    DownHeader35,
    WheelSpinEvent
  },
  // ui_version
  data() {
    return {
      isConterType: 2
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>
<style scoped></style>
